<template>
  <div class="info-region-container">
    <div class="all-content-container" v-allow="'0604'" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>提醒用户配置</h4>
          <el-button v-allow="'060402'" type="primary" class="adduser" @click="add">添加</el-button>
        </div>
        <el-form :inline="true" :model="dialogformInline" class="demo-form-inline">
          <el-form-item label="类型">
            <el-select v-model="dialogformInline.type" clearable placeholder="请选择类型">
              <el-option v-for="item in typelist" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账户：">
            <el-input v-model="dialogformInline.account" clearable placeholder="请输入账户" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input v-model="dialogformInline.realName" clearable placeholder="请输入姓名" maxlength="20"></el-input>
          </el-form-item>

          <el-form-item v-allow="'060401'">
            <el-button type="primary" class="button" @click="onSubmit()">查询</el-button>
            <el-button type="button" ass="button" @click="resetBth()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="type" align="center" label="类型">
              <template slot-scope="scope">
                <p>{{ scope.row.type | pushusertype }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="account" align="center" label="账户"></el-table-column>
            <el-table-column prop="realName" align="center" label="姓名">
            </el-table-column>

            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button v-allow="'060403'" @click="handleClick(scope.row.id, 'edit')" type="text"
                  size="small">编辑</el-button>
                <el-button v-allow="'060404'" type="text" size="small"
                  @click="delObjDeviceAttributeAlarm(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap"
              @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize"
              :total="total"></el-pagination>
          </div>
        </div>
        <!-- 添加编辑 -->
        <el-dialog :title="dialogTitle" :visible.sync="centerDialogVisible" width="600px" center style="z-index: 10000"
          @closed="resetForm">
          <el-form ref="dialogformInlineadd" :model="dialogformInlineadd" :rules="dialogRules" label-width="120px"
            class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="类型：" prop="type">
                  <el-select v-model="dialogformInlineadd.type" placeholder="请选择类型" clearable>
                    <el-option v-for="item in typelist" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="账户：" prop="account">
                  <el-input v-model="dialogformInlineadd.account" clearable placeholder="请输入账户" maxlength="20"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="姓名：" prop="realName">
                  <el-input v-model="dialogformInlineadd.realName" clearable placeholder="请输入姓名"
                    maxlength="20"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm">取消</el-button>
            <el-button type="primary" @click="submitForm('dialogformInlineadd')">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "alarmConfiguration",
  data() {
    var isTPhone = (rule, value, callback) => {
      if (this.dialogformInlineadd.type == "0") {
        //手机号
        if (!this.$utils.telphone(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      } else if (this.dialogformInlineadd.type == "1") {
        //邮箱
        if (!this.$utils.isEmail(value)) {
          callback(new Error("请输入正确的邮箱"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请输入账户"));
      }
    };

    return {
      typelist: [
        {
          name: "手机号",
          id: 0,
        },
        {
          name: "邮箱",
          id: 1,
        },
      ],
      pushModeoptions: [
        {
          value: "0",
          label: "邮箱发送",
        },
        {
          value: "1",
          label: "短信发送",
        },
        {
          value: "2",
          label: "APP推送",
        },
        {
          value: "3",
          label: "小程序推送",
        },
        {
          value: "4",
          label: "语音拨号提醒",
        },
      ],
      centerDialogVisible: false,
      sceneListData: [],
      attributeLiST: [],
      value: "",
      allSysUserList: [], //查询所有用户
      editId: "", //详情id（查询详情时使用））
      id: "",
      list: [], //审批模板详情表(对象)
      remark: "", //备注
      title: "", //标题
      updateId: "", //创建修改人员id
      updateTime: "", //创建修改时间
      dialogTitle: "",
      pagesize: 10,
      currentPage: 1,
      total: 0,
      loading: false, //加载
      genderList: [
        {
          value: "0",
          name: "男",
        },
        {
          value: "1",
          name: "女",
        },
      ],

      dialogformInline: {
        //查询条件（参数）
        type: "",
        realName: "",
        account: "",
      },
      templateNameList: [],
      sensorNameList: [],
      dialogformInlineadd: {
        //添加参数或者编辑参数
        type: "",
        realName: "",
        account: "",
      },
      dialogRules: {
        // 弹框表单验证

        realName: [
          { required: true, message: "请输入姓名", trigger: "change" },
        ],
        account: [{ required: true, validator: isTPhone, trigger: "change" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
      modelNoListData: [
        {
          label: "全部",
          id: -1,
        },
        {
          label: "管理员",
          id: 0,
        },
        {
          label: "普通用户",
          id: 1,
        },
      ],
      organizationList: [
        {
          label: "全部",
          id: -1,
        },
        {
          label: "武汉",
          id: 0,
        },
        {
          label: "上海",
          id: 1,
        },
      ],

      tableData: [],
      noneList: [],
      editId: "",
      centerDialogVisible: false,
    };
  },

  created() {
    this.getObjDeviceAttributeAlarmList(); ///查询告警配置列表
  },
  methods: {
    resetForm() {
      this.currentPage = 1;
      this.centerDialogVisible = false;
      this.$refs["dialogformInlineadd"].resetFields();
    },
    // 重置
    resetBth() {
      this.dialogformInline.type = "";
      this.dialogformInline.realName = "";
      this.dialogformInline.account = "";
      this.onSubmit();
    },

    handleCurrentChange(currentPage) {
      //下一页
      this.currentPage = currentPage;
      this.getObjDeviceAttributeAlarmList(); //查询列表
    },
    // 查询
    onSubmit() {
      this.getObjDeviceAttributeAlarmList(); //查询列表
    },
    //查询告警配置列表
    getObjDeviceAttributeAlarmList() {
      this.loading = true; //加载
      var formdata = {
        pageNum: this.currentPage, //第几页，默认1
        pagesize: this.pagesize, //默认展示多少条，默认10
        type: this.dialogformInline.type,
        realName: this.dialogformInline.realName,
        account: this.dialogformInline.account,
      };
      this.$api.system
        .getPushUserList(formdata)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.loading = false; //关闭加载
            this.total = res.count; //
          } else {
            this.loading = false; //关闭加载
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //删除
    delObjDeviceAttributeAlarm(id) {
      this.$confirm("是否删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.system
            .delfun(`/pc/sysPushUser/delPushUser`, id)
            .then((res) => {
              if (res.code == 200) {
                this.getObjDeviceAttributeAlarmList(); //列表刷新
                this.$message({
                  type: "success",
                  message: res.msg,
                });
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    add() {
      //添加（新增保存审批模板）
      this.dialogformInlineadd.id = ""; //清空
      this.dialogTitle = "添加提醒用户配置";
      this.centerDialogVisible = true;
      // this.empty()
    },
    //  查询全部传感器
    getNumericals() {
      this.$api.system.getNumericals().then((res) => {
        if (res.code == 200) {
          this.sensorNameList = res.data; //全部传感器
        } else {
          this.$meessage.error(res.msg);
        }
      });
    },

    handleClick(id, type) {
      if (type == "edit") {
        this.editId = id;
        this.dialogTitle = "编辑提醒用户配置";
        this.centerDialogVisible = true;

        this.getObjDeviceAttributeAlarm(id); //查询告警配置详情
        this.dialogformInlineadd.id = id;
      }
    },

    empty() {
      this.dialogformInlineadd.attributeId = "";
      this.dialogformInlineadd.eid = ""; //清空
      this.dialogformInlineadd.modelAlarmSettingsId = ""; //清空
      this.this.dialogTitle = "";
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogTitle == "添加提醒用户配置") {
            //新增

            this.saveObjDeviceAttributeAlarm("");
          } else {
            //编辑
            this.saveObjDeviceAttributeAlarm(this.dialogformInlineadd.id);
          }
        } else {
          return false;
        }
      });
    },
    cancellation() {
      //弹框取消时
      this.centerDialogVisible = false;
    },

    //编辑时获取数据  查询告警配置详情
    getObjDeviceAttributeAlarm(id) {
      var formdata = {
        id: id,
      };
      this.$api.system
        .getPushUser(
          formdata //详情id（查询详情时使用））
        )
        .then((res) => {
          if (res.code == 200) {
            this.dialogformInlineadd.account = res.data.account;
            this.dialogformInlineadd.realName = res.data.realName;
            this.dialogformInlineadd.type = res.data.type;
          } else {
            this.$meessage.error(res.msg);
          }
        });
    },

    //新增环节
    addNode() {
      this.noneList.push("");
    },
    //查询全部告警模板
    getModelAlarmSettingss() {
      this.$api.system.getModelAlarmSettingss().then((res) => {
        if (res.code == 200) {
          var obj = {};
          obj.name = "全部";
          obj.id = "";
          res.data.unshift(obj);
          this.templateNameList = res.data; //全部告警模板
        } else {
          this.$meessage.error(res.msg);
        }
      });
    },
    //查询全部属性名称
    getModelRuleAttributes(id) {
      this.$api.system.getModelRuleAttributes(id).then((res) => {
        if (res.code == 200) {
          //  var obj={}
          // obj.cname='全部'
          // obj.id=''
          // res.data.unshift(obj)
          this.attributeLiST = res.data; //全部告警模板
        } else {
          this.$meessage.error(res.msg);
        }
      });
    },
    // 保存告警配置
    saveObjDeviceAttributeAlarm(id) {
      var formdata = {
        account: this.dialogformInlineadd.account,
        realName: this.dialogformInlineadd.realName,
        type: this.dialogformInlineadd.type,
        id: id,
      };
      this.$api.system.savePushUser(formdata).then((res) => {
        if (res.code == 200) {
          this.centerDialogVisible = false;
          this.getObjDeviceAttributeAlarmList();
          if (id != "" || id) {
            this.$message({ type: "success", message: "编辑成功" });
          } else {
            this.$message({ type: "success", message: res.msg });
          }
        } else {
          this.centerDialogVisible = false;
          this.$meessage.error(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>